// 发票申请工单
<template>
  <div class="woStyle">
    <div class="backBtn">
      <el-button
        type="primary"
        size="mini"
        @click="backWorkOrder()"
        v-if="isSign == 0"
        >返回</el-button
      >
    </div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="125px"
      class="demo-ruleForm"
      label-position="right"
    >
      <h3>开具发票申请</h3>
      <div>
        <el-form-item
          label="销售方发票抬头"
          prop="invoice_title"
          :class="className"
        >
          <el-select
            v-model="ruleForm.invoice_title"
            placeholder="请选择发票抬头"
            style="width:100%;"
          >
            <el-option
              label="杭州百博电子商务有限公司"
              value="杭州百博电子商务有限公司"
            ></el-option>
            <el-option
              label="杭州百博知识产权有限公司"
              value="杭州百博知识产权有限公司"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专票/普票" prop="type" :class="className">
          <el-select
            v-model="ruleForm.type"
            placeholder="请选择发票抬头"
            style="width:100%;"
          >
            <el-option label="专票" value="1"></el-option>
            <el-option label="普票" value="2"></el-option>
            <el-option label="形式发票" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开票金额" prop="money" :class="className">
          <el-input v-model="ruleForm.money"></el-input>
        </el-form-item>
        <el-form-item
          label="购买方发票抬头"
          prop="buy_invoice_title"
          :class="className"
        >
          <el-input v-model="ruleForm.buy_invoice_title"></el-input>
        </el-form-item>
        <el-form-item label="税号" prop="paragraph" :class="className">
          <el-input v-model="ruleForm.paragraph"></el-input>
        </el-form-item>
        <!-- <el-form-item label="销售姓名" prop="sale_id" :class="className">
                <el-select v-model="ruleForm.sale_id" placeholder="请选择销售" style="width:100%;">
                    <el-option 
                    v-for="item in salePersonOptions"
                    :key="item.value"
                    :label="item.label" 
                    :value="item.value"></el-option>
                    
                </el-select>
            </el-form-item> -->
        <el-form-item label="是否为提前开票" prop="state" :class="className">
          <el-select
            v-model="ruleForm.state"
            placeholder="请选择"
            style="width:100%;"
          >
            <el-option label="否" value="0"></el-option>
            <el-option label="是" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="到单时间" prop="order_time" :class="className">
          <el-date-picker
            style="width:100%;"
            v-model="ruleForm.order_time"
            type="date"
            placeholder="选择到单日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="收件人" prop="addressee" :class="className">
          <el-input v-model="ruleForm.addressee"></el-input>
        </el-form-item>
        <el-form-item
          label="联系方式"
          prop="contact_information"
          :class="className"
        >
          <el-input v-model.number="ruleForm.contact_information"></el-input>
        </el-form-item>
        <el-form-item label="地址" prop="address" :class="className">
          <el-input v-model="ruleForm.address"></el-input>
        </el-form-item>
        <el-form-item label="是否续签" prop="is_renewal" :class="className">
          <el-select
            v-model="ruleForm.is_renewal"
            placeholder="请确认是否为续签"
            style="width:100%;"
            disabled
          >
            <el-option label="否" value="0"></el-option>
            <el-option label="是" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户名称" prop="c_id" :class="className">
          <!-- <el-input v-model="ruleForm.c_id"></el-input> -->
          <el-autocomplete
            class="inline-input"
            v-model="ruleForm.c_name"
            value-key="label"
            :fetch-suggestions="querySearch"
            placeholder="请输入内容"
            @select="handleSelect"
            style="width:100%;"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item
          label="注册地址和电话"
          prop="address_and_telephone"
          :class="className"
        >
          <el-input
            type="textarea"
            v-model.number="ruleForm.address_and_telephone"
            autosize
          ></el-input>
        </el-form-item>
        <el-form-item
          label="银行名称和账号"
          prop="bank_and_account"
          :class="className"
        >
          <el-input
            type="textarea"
            v-model="ruleForm.bank_and_account"
            autosize
          ></el-input>
        </el-form-item>
      </div>

      <!-- 按钮区域 -->
      <el-form-item>
        <el-button
          type="primary"
          @click="submitForm('ruleForm')"
          :loading="btnState"
          >确认</el-button
        >
        <el-button @click="resetForm('ruleForm')" :loading="btnState"
          >重置</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import utils from "../../libs/utils.js";
import api from "../../api";
export default {
  props: {
    reviseFormData: {
      // 通过修改窗口传来的现有表单信息
      type: Object,
      default: () => {
        return {};
      },
    },
    className: {
      type: String,
      default: "formItems",
    },
    renewalSign: {
      // 是否是续签客户标识
      type: String,
      default: "",
    },
    handle_id: {
      // 操作的信息的id
      type: String,
    },
  },

  data() {
    let checkphone = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("请输入手机号"));
      } else if (!utils.isCellPhone(value)) {
        callback(new Error("请输入正确的手机号!"));
      } else {
        callback();
      }
    };
    return {
      btnState: false,
      // 销售选项
      ruleForm: {
        invoice_title: "", //销售方发票抬头
        type: "", // 发票类型
        money: "", // 开票金额
        buy_invoice_title: "", // 购买方发票抬头
        paragraph: "", // 税号
        address_and_telephone: "", // 注册地址和电话
        bank_and_account: "", // 银行名称和账号
        // sale_id:'',//销售
        state: "", // 是否为提前开票
        order_time: "", // 到单时间
        addressee: "", // 收件人
        contact_information: "", // 联系方式
        address: "", // 地址
        is_renewal: "0", // 是否续签（0 否 1是）
        c_id: "", // 客户ID
        c_name: "", // 客户名称
        is_invoiced: "0", // 是否已开发票 0 否 1 是
      },
      rules: {
        invoice_title: [
          { required: true, message: "请填入抬头", trigger: "change" },
        ],
        type: [
          { required: true, message: "请选择发票类型", trigger: "change" },
        ],
        money: [{ required: true, message: "请输入开票金额", trigger: "blur" }],
        buy_invoice_title: [
          { required: true, message: "请输入购买方发票抬头", trigger: "blur" },
        ],
        paragraph: [{ required: true, message: "请输入税号", trigger: "blur" }],
        address_and_telephone: [
          { required: true, message: "请输入注册地址和电话", trigger: "blur" },
        ],
        bank_and_account: [
          { required: true, message: "请输入银行名称和账号", trigger: "blur" },
        ],
        // sale_id:[
        //     { required: true, message: '请选择销售', trigger: 'change' }
        // ],
        state: [{ required: true, message: "请选择状态", trigger: "change" }],
        order_time: [
          { required: true, message: "请选择到单时间", trigger: "change" },
        ],
        addressee: [
          { required: true, message: "请输入收件人", trigger: "blur" },
        ],
        contact_information: [
          { required: true, message: "请输入联系方式", trigger: "blur" },
          { type: "number", message: "请输入数字" },
          { validator: checkphone },
        ],
        address: [{ required: true, message: "请输入地址", trigger: "blur" }],
        is_renewal: [
          { required: true, message: "请选择是否续签", trigger: "change" },
        ],
        c_id: [{ required: true, message: "请选择客户", trigger: "change" }],
      },
      isSign: 0, // 组件状态 0：提交工单中新建   1：弹窗中新建   2：修改信息
      restaurants: [], // 模糊查询---客户名称数据
    };
  },
  watch: {
    ruleForm: {
      handler: function(val, oldval) {
        if (this.isSign == 0) {
          utils.sessionSetStore("invoiceFormData", val); // 如果是新建，输入内容缓存
        }
      },
      deep: true,
    },
  },
  computed: {
    salePersonOptions() {
      return this.$store.getters.salePersonOptions;
    },
  },
  methods: {
    // 返回按钮
    backWorkOrder() {
      window.history.go(0);
    },
    // 重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 工单提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 提交按钮状态更新
          this.btnState = true;

          let paramObj = this.ruleForm;

          if (!this.isSign == 2) {
            // 修改信息

            api
              .reviseInvoiceList(paramObj)
              .then((res) => {
                // console.log('返回值',res)
                utils.notificationInfo("提示", "修改信息成功", "success");
                // 提交按钮状态更新
                this.btnState = false;
                // 重置表单
                this.$refs[formName].resetFields();
                setTimeout(function() {
                  window.location.reload();
                }, 500);
              })
              .catch((err) => {
                // 提交按钮状态更新
                this.btnState = false;
                console.log(err);
                utils.notificationInfo("提示", "修改信息失败", "error");
              });
          } else {
            // 新建发票申请
            paramObj.sale_id = this.userId;

            if (this.isSign == 1) {
              paramObj.c_id = this.handle_id;
            }

            api
              .newInvoiceApply(paramObj)
              .then((res) => {
                // 提交按钮状态更新
                this.btnState = false;
                // console.log(res)
                // 每个客户只能申请开具一次发票
                if (res.data.code == 999) {
                  this.$message({
                    type: "warning",
                    message: res.data.msg,
                  });
                  return;
                }

                utils.notificationInfo("提示", "发票申请创建成功", "success");

                // 提交工单页面新建
                if (this.isSign == 0) {
                  // 传给父组件
                  this.$emit("completeView", "true");

                  // 清除缓存的表单信息
                  utils.sessionRemoveStore("invoiceFormData");
                } else {
                  // 弹窗新建
                  this.$refs[formName].resetFields();
                  setTimeout(function() {
                    window.location.reload();
                  }, 500);
                }
              })
              .catch((error) => {
                // 提交按钮状态更新
                this.btnState = false;
                utils.notificationInfo("提示", "提交失败", "warning");
                return Promise.reject(error);
              });
          }
        } else {
          utils.notificationInfo("提示", "提交失败", "warning");
          return false;
        }
      });
    },

    // 客户名称相关
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.label.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    // 客户名称数据
    loadAll() {
      let paramObj = {
        id: this.userId,
        is_contract: 0,
      };
      api.getCustomersData(paramObj).then((res) => {
        // console.log(res)
        let records = res.data.data.list;
        records.forEach((item) => {
          this.restaurants.push({
            label: item.corporate_name,
            value: item.id,
          });
        });
      });
    },
    handleSelect(item) {
      // console.log(item);
      this.ruleForm.c_id = item.value;
    },
  },
  mounted() {
    //获取用户id
    this.userId = utils.sessionGetStore("user_id");
    this.userName = utils.sessionGetStore("user_name");

    // this.isSign = Object.keys(this.reviseFormData).length == 0 ? true : false
    if (Object.keys(this.reviseFormData).length == 0) {
      // 新建---再判断是否是在弹窗中新建
      if (this.renewalSign != "") {
        // 弹窗中新建
        this.isSign = 1;
        this.ruleForm.is_renewal = this.renewalSign;
      }
    } else {
      // 修改
      this.isSign = 2;
    }

    // 判断是否是新建，是----获取本地已填表单
    if (this.isSign != 2) {
      let formData = JSON.parse(utils.sessionGetStore("invoiceFormData"));
      // console.log('新建来的')
      if (formData) {
        Object.keys(formData).forEach((item) => {
          this.ruleForm[item] = formData[item];
        });
      }
    } else {
      // 修改窗口调用了该组件，将现有内容赋值给表单
      Object.keys(this.ruleForm).forEach((item) => {
        this.ruleForm[item] = this.reviseFormData[item];
      });
      this.ruleForm.id = this.reviseFormData.id;
      // console.log('修改来的',this.ruleForm)
    }

    // 获取客户名称列表
    this.loadAll();
  },
};
</script>

<style lang="scss" scoped>
.formItems {
  width: 30%;
  margin: 20px 1% !important;
}
.formItems2 {
  width: 100%;
  margin: 20px 1% !important;
}

.el-form-item {
  ::v-deep .el-form-item__label {
    font-size: 12px;
  }
}
</style>
